import script from "./TressPaginationAnnouncer.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressPaginationAnnouncer.vue?vue&type=script&setup=true&lang=ts"

import "./TressPaginationAnnouncer.vue?vue&type=style&index=0&id=6f253337&lang=scss"

const __exports__ = script;

export default __exports__